import { useSelector } from 'src/hooks/useSelector';

export const useHiringManagerCommentButton = (): boolean => {
    const { vacancyId } = useSelector((state) => state.router.location.query);
    const isHiringManager = useSelector((state) => state.isHiringManager);
    const hasSharedVacancy = useSelector((state) => !!state.hiringManagerVacancyPermission);

    return !!vacancyId && (isHiringManager || hasSharedVacancy);
};
